import { render } from "./game-modal.vue?vue&type=template&id=11570cc8&scoped=true"
import script from "./game-modal.vue?vue&type=script&lang=js"
export * from "./game-modal.vue?vue&type=script&lang=js"

import "./game-modal.vue?vue&type=style&index=0&id=11570cc8&scoped=true&lang=css"
import "../../../assets/css/desktop.css?vue&type=style&index=1&id=11570cc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11570cc8"

export default script